import { useEffect } from 'react';

import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types';

import type { AIDefinitionsPlugin } from '../../aiDefinitionsPluginType';

export function useManageSelectionToolbarVisibility({
	api,
	show,
}: {
	api?: ExtractInjectionAPI<AIDefinitionsPlugin>;
	show: boolean;
}): void {
	useEffect(() => {
		if (show) {
			api?.selectionToolbar.actions?.suppressToolbar?.();
		} else {
			api?.selectionToolbar.actions?.unsuppressToolbar?.();
		}

		return () => {
			api?.selectionToolbar.actions?.unsuppressToolbar?.();
		};
	}, [api, show]);
}
